/** Sablon gorselleri: renk/beden tablosu listenin SONUNDA kaliyordu, alici
 *  goremeden renk seciyordu — 5. siradan itibaren yerlestirilir. "info"
 *  etiketliler (siparis talimati, bakim, kargo...) en sonda kalir. Takida
 *  (kendi chart akisi var) hepsi eskisi gibi sona. */
export const CHART_SLOT = 4;
export const INFO_LABEL = "info";
const slotFor = (len: number, vertical?: string | null) => (vertical === "jewelry" ? len : Math.min(CHART_SLOT, len));

/** Listede olmayan sablon gorsellerini ekler: tablolar CHART_SLOT'a, "info"
 *  etiketliler sona. Zaten listedekilerin yerine dokunulmaz. Etsy siniri 20. */
export function mergeTemplateImages(
  images: string[], templateImages: unknown[] | null | undefined, vertical?: string | null, templateLabels?: unknown,
): string[] {
  const out = [...images];
  const labels = Array.isArray(templateLabels) ? (templateLabels as unknown[]) : [];
  const add = (templateImages ?? []).map((u, i) => ({ u, info: labels[i] === INFO_LABEL }))
    .filter((x, i, a): x is { u: string; info: boolean } => typeof x.u === "string" && !!x.u && !out.includes(x.u) && a.findIndex((y) => y.u === x.u) === i);
  out.splice(slotFor(out.length, vertical), 0, ...add.filter((x) => !x.info).map((x) => x.u));
  out.push(...add.filter((x) => x.info).map((x) => x.u));
  return out.slice(0, 20);
}

/** Etiketi "chart" iceren gorselleri CHART_SLOT'a, "info" etiketlileri sona
 *  tasir; digerlerinin sirasi korunur. */
export function placeChartImages(urls: string[], labels: string[], vertical?: string | null): { imageUrls: string[]; imageLabels: string[] } {
  const kind = (i: number) => (labels[i] === INFO_LABEL ? "info" : (labels[i] || "").includes("chart") ? "chart" : "own");
  const idx = urls.map((_, i) => i);
  const order = idx.filter((i) => kind(i) === "own");
  order.splice(slotFor(order.length, vertical), 0, ...idx.filter((i) => kind(i) === "chart"));
  order.push(...idx.filter((i) => kind(i) === "info"));
  return { imageUrls: order.map((i) => urls[i]), imageLabels: order.map((i) => labels[i] || "") };
}

/** Sablon kaydindaki gorsel etiketleri (attributes.imageLabels) */
export function templateImageLabels(attributes: unknown): string[] {
  const l = (attributes as { imageLabels?: unknown } | null)?.imageLabels;
  return Array.isArray(l) ? l.map((x) => (typeof x === "string" ? x : "")) : [];
}
